(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/racing/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/utils/racing/assets/javascripts/prescript.js');
(function() {
  svs.utils = svs.utils || {};
  svs.utils.racing = svs.utils.racing || {};
})();


 })(window);